export default {
  fileType_list: [],
  allFile: [],
  allFile_list: [],
};
